module.exports = __webpack_public_path__ + "static/media/close.897c46f0.svg";